module.exports = __webpack_public_path__ + "img/3ef52a4.jpg";